import { gql } from "@apollo/client"

export const GET_TOURNAMENT_LIST = gql`
  query TournamentListV2($TournamentListInputV2: TournamentListInputV2!) {
    TournamentListV2(input: $TournamentListInputV2) {
      status {
        success
        name
        detail
      }
      hasNextPage
      Tournaments {
        id
        name
        urlView
        urlImage
        startDate
        maxPlayers
        rounds
        isPresential
        isPrivate
        statusId
        role
        Store {
          urlView
          name
        }
        Format {
          name
        }
        TournamentType {
          name
          urlImage
          urlImage2
          urlImage3
          urlImage4
        }
        TournamentStatus {
          name
          description
          style
          icon
        }
        Game {
          id
          name
          color
          icon
          urlImage
          image
        }
        Address {
          countryName
          countryId
        }
      }
    }
  }
`

export const GET_TOURNAMENT_LIST_RESUMED = gql`
  query TournamentListV2($TournamentListInputV2: TournamentListInputV2!) {
    TournamentListV2(input: $TournamentListInputV2) {
      status {
        success
        name
        detail
      }
      Tournaments {
        name
        urlView
        statusId
        Game {
          name
        }
        Store {
          name
        }
      }
    }
  }
`
